import React, { useMemo } from 'react'
import { Context } from './Context'
import { RenderTableColumns } from './RenderTableColumns'
import styles from './Table.module.scss'
import cl from 'classnames'
import { useTranslation } from 'react-i18next'
import { Loader } from '@/components/Loader'

export const Table = ({
	children,
	data,
	tableName = 'table',
	emptyPlaceholder = '',
	onRowClick,
	tableClassName,
	wrapperClassName,
	locale,
	loading = false,
}) => {
	const { t } = useTranslation()

	const contextValue = useMemo(
		() => ({
			data,
			tableName,
			emptyPlaceholder,
		}),
		[data, emptyPlaceholder, tableName]
	)

	return (
		<div className={cl(styles.wrapper, wrapperClassName)}>
			<table className={cl(styles.table, tableClassName)}>
				<Context.Provider value={contextValue}>
					<RenderTableColumns onRowClick={onRowClick}>{children}</RenderTableColumns>
				</Context.Provider>
			</table>
			{!data.length && !loading && (
				<h5 className={cl(styles.statuses, styles.statusesText)}>{locale?.emptyText || t('empty_table')}</h5>
			)}

			{loading && (
				<div className={cl(styles.statuses, 'flex', 'flex-column', 'align-items-center', 'gap-3')}>
					<Loader />
					<h5 className={cl(styles.statusesText)}>{locale?.loadingText || t('please_wait')}</h5>
				</div>
			)}
		</div>
	)
}
